export default __webpack_public_path__ + "i18n/ko.479a3d3ce97db6cdce7532b852723166.json";